module.exports = __webpack_public_path__ + "img/programme5.b4919709.png";